import { ParsedUrlQuery } from 'querystring';
import Router, { NextRouter } from 'next/router';
import * as storage from '@/legacy/utils/storage';

export const DEFAULT_CLIENT_PATH = '/explorer';

export const openLinkInNewTab = (url: string) => {
  window.open(url, '_blank');
};

export const redirectTo = (url: string) => {
  if (window && url.includes('://')) {
    window.location.href = url;
  } else {
    Router.push(url);
  }
};

export const copyTextToClipboard = (text: string) => {
  if (!navigator.clipboard) {
    //TODO - should we use this? - https://github.com/bence-toth/react-hook-clipboard
    // use old commandExec() way?
    //maybe not? https://caniuse.com/#feat=clipboard
  } else {
    navigator.clipboard
      .writeText(text)
      .then(function () {
        console.log('copied');
      })
      .catch(function () {
        console.log('copy error');
      });
  }
};

export const buildQueryParamString = (
  urlQuery: ParsedUrlQuery,
  exclude?: string,
) => {
  let params = '';
  for (const property in urlQuery) {
    if (property !== exclude) {
      params += `${params ? '&' : '?'}${property}=${urlQuery[property]}`;
    }
  }
  return params;
};

export const getQueryParam = (
  param: string,
  router?: NextRouter,
  andLocalStorage?: boolean,
): string => {
  let queryParam = router?.query?.[param];
  if (!queryParam && andLocalStorage) {
    const pageName = window.location.pathname;
    queryParam = storage.get(`${pageName}_query_${param}`);
  }
  return (queryParam || '').toString();
};

export const updateQueryParam = (
  param: string,
  newValue: string,
  andLocalStorage?: boolean,
  router?: NextRouter,
  saveRouterHistory = true,
) => {
  const url = new URL(window.location.href);
  if (newValue) {
    url.searchParams.set(param, newValue);
  } else {
    url.searchParams.delete(param);
  }

  if (router) {
    if (saveRouterHistory) {
      router.push(url, undefined, { shallow: true });
    } else {
      router.replace(url, undefined, { shallow: true });
    }
  } else {
    history.replaceState(null, '', url.toString());
  }
  if (andLocalStorage) {
    const pageName = window.location.pathname;
    storage.set(`${pageName}_query_${param}`, newValue);
  }
};

export const stripQueryParamsFromPath = (path: string) => {
  return path.replace(/\?.*$/, '');
};

export const isCurrentPage = (router: NextRouter, url: string) => {
  if (router.asPath.includes(url)) {
    return true;
  }
  return false;
};

export const ExternalUrls = {
  PurchaseDashcam:
    'https://hivemapper.myshopify.com/collections/frontpage/products/blackvue-dr900s-1ch-4k-dashcam-1-channel-128gb-sd-card',
  Docs: 'https://docs.hivemapper.com/',
  ContributeGuide: 'https://docs.hivemapper.com/start-mapping/driving',
  ContributeWithDashcam: 'https://docs.hivemapper.com/contribute/dashcam',
  MapApi: 'https://docs.hivemapper.com/main-concepts/map-image-api',
  Upload: 'https://docs.hivemapper.com/contribute/dashcam/5-upload-content',
  UploadVideo: 'https://www.youtube.com/watch?v=CqX5VZJXGe8',
  PreOrder: 'https://shop.hivemapper.com/',
  CryptoToken: 'https://coinmarketcap.com/currencies/solana/',
  Dashcam: 'https://admin.hivemapper.com/hivemapper-dashcam',
  FAQ: 'https://docs.hivemapper.com/resources/frequently-asked-questions',
  HowItWorks: 'https://admin.hivemapper.com/mapping-network#introduction',
  Pricing: 'https://admin.hivemapper.com/pricing',
  Honey:
    'https://solscan.io/token/4vMsoUT2BWatFweudnQM1xedRLfJgJ7hswhcpz4xgBTy#analysis',
  Mapbox: 'https://www.mapbox.com/about/maps',
  OSM: 'https://www.openstreetmap.org/copyright',
  ImproveMap: 'https://www.mapbox.com/map-feedback',
  BuyADashcam:
    'https://shop.hivemapper.com/?utm_source=salebutton&utm_medium=organic&utm_campaign=salebutton&utm_id=1212023',
  AITrainerDocs: 'https://docs.hivemapper.com/start-mapping/train-map-ai',
  BeeDashcamStore: 'https://bee.hivemapper.com/',
  MapWithPhone: 'https://docs.hivemapper.com/start-mapping/map-with-phone',
  MapDataConsole: 'https://docs.hivemapper.com/use-the-map/console',
  Scout: 'https://docs.hivemapper.com/use-the-map/scout',
  ScoutHostedService:
    'https://docs.hivemapper.com/use-the-map/scout/scout-hosted-service',
  MapProducts: 'https://admin.hivemapper.com/tos/map-products/#introduction',
  ImageApiDriveDocs:
    'https://drive.google.com/drive/folders/1-u_OxIadl1GkiJvufk_GBJYXxkU7MdV9',
};
